<header class="mb-4 hidden rounded-3xl bg-white p-8 md:block">
  <div class="flex items-center justify-end gap-6">
    <a
      app-button
      color="secondary"
      size="sm"
      class="cursor-pointer"
      translate
      target="_blank"
      [href]="zgUrls[currentLang]">
      lbl.visitOfficalSite
    </a>
    <!-- <a href="#">
      <app-icon name="plus-circle"></app-icon>
    </a> -->
    <div class="relative cursor-pointer" (click)="toggleNotification()">
      <span
        class="absolute right-1 top-0.5 h-1.5 w-1.5 rounded-full bg-primary-600"
        *ngIf="unReadMsgCount()! > 0"></span>
      <app-icon name="bell" />
    </div>
    <div class="flex items-center">
      <app-avatar [name]="loggedInName ?? ''"></app-avatar>
      <p class="prose prose-text-md ml-3">{{ loggedInName }}</p>
    </div>
  </div>
</header>
<header class="block md:hidden"></header>
